import React from 'react';
import './ImagePreviewModal.css';

const ImagePreviewModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="imagepreview-modal-overlay">
            <div className="imagepreview-modal-content">
                <button className="imagepreview-modal-close-button" onClick={onClose}>×</button>
                {children}
            </div>
        </div>
    );
};

export default ImagePreviewModal;
